export default __webpack_public_path__ + "static/media/CONTE_LEGENDE.b6ce6a29.svg";